export class ProductBillingRule {
    id: number;
    ruleName: string;
    ruleType: ProductBillingRuleType;
    subType : ProductBillingRuleSubType;
    transactionFee: number;
    transactionFeeTitle: string;
    ratePerUnit: number;
    ratePerUnitTitle: string;
    reportCredit: number;
    reportCreditTitle: string;
    rentalUnitCount: number;
    goLiveDate: any;
    billingRuleOverridePrice : number;
    additionalItemFee: number;
    
    public get ruleTypeName() : string {
        if(this.ruleType == 0) return 'Transactional';
        else return 'Rate Per Unit';
    }
    
}

export class BillingRuleAssignment {
    Rule: ProductBillingRule;
    DateObj: any;
    PropertyId: number;
    billingRuleOverridePrice : number;
    additionalItemFee: number;
}

export enum ProductBillingRuleType { 
    Transactional = 0,
    RatePerUnit = 1,
    AdHoc = 2
}

export enum ProductBillingRuleSubType
{ 
    Default = 0,
    IncomeVerAdhoc = 1
}